import { Outlet } from "react-router-dom";
import { Box, Toolbar, Typography } from "@mui/material";
import sizeConfigs from "../../configs/sizeConfigs";
import Sidebar from "../common/Sidebar";
import { useLocation } from "react-router-dom";
import FolderIcon from "@mui/icons-material/Folder";
import { useNavigate } from "react-router-dom";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import backgroundimage from "../../assets/images/backgroundimage.jpg";
import ChatBotIcon from "../../assets/images/chatBot1.png";
import { useEffect, useState } from "react";
import ChatBot from "../../pages/ChatBot/ChatBot";
import { secureGetItem } from "../../utils/encryption"; // Import the secure function

const colorConfigs = {
  sidebar: {
    bg: "#233044",
    color: "#eeeeee",
    hoverBg: "#1e293a",
    activeBg: "#1e253a",
  },
  topbar: {
    bg: "#fff",
    color: "#000",
  },
  mainBg: `url(${backgroundimage})`,
};

const MainLayout = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkUserAndBuildMenu = () => {
      try {
        // Use secureGetItem instead of localStorage.getItem
        const items2 = secureGetItem("userdata");
        
        if (!items2 || items2.length === 0) {
          if (location.pathname !== "/") {
            navigate("/");
          }
          setLoading(false);
          return;
        }

        // Build menu items from encrypted data
        const items1 = items2[0]["userPermission"][0]["parentMenu"];
        const menuarray = [];

        for (let index = 0; index < items1.length; index++) {
          const element = items1[index];
          const childmenuarray = [];
          const childMenu = items1[index]["childMenu"];

          for (let index2 = 0; index2 < childMenu.length; index2++) {
            childmenuarray.push({
              id: childMenu[index2]["menuId"],
              name: childMenu[index2]["menuName"],
              label: childMenu[index2]["menuName"],
              path: childMenu[index2]["path"],
              displayNo: childMenu[index2]["displayNo"],
              Icon: TouchAppIcon,
              onClick: (e: any, item: any) => handleMenuItemClick(e, item),
            });
          }
          
          menuarray.push({
            id: items1[index]["menuId"],
            name: items1[index]["menuName"],
            label: items1[index]["menuName"],
            displayNo: items1[index]["displayNo"],
            path: "",
            Icon: FolderIcon,
            items: childmenuarray.sort((a, b) => a.displayNo - b.displayNo),
          });
        }

        const sortedItems = menuarray.sort((a, b) => a.displayNo - b.displayNo);
        setMenuItems(sortedItems);
        setLoading(false);
        
      } catch (error) {
        console.error("Error processing user data:", error);
        
        // Fallback: try regular localStorage
        try {
          const fallbackData = localStorage.getItem("userdata");
          if (fallbackData) {
            const items2 = JSON.parse(fallbackData);
            if (items2 && items2.length > 0) {
              // Build menu items from fallback data
              const items1 = items2[0]["userPermission"][0]["parentMenu"];
              const menuarray = [];

              for (let index = 0; index < items1.length; index++) {
                const element = items1[index];
                const childmenuarray = [];
                const childMenu = items1[index]["childMenu"];

                for (let index2 = 0; index2 < childMenu.length; index2++) {
                  childmenuarray.push({
                    id: childMenu[index2]["menuId"],
                    name: childMenu[index2]["menuName"],
                    label: childMenu[index2]["menuName"],
                    path: childMenu[index2]["path"],
                    displayNo: childMenu[index2]["displayNo"],
                    Icon: TouchAppIcon,
                    onClick: (e: any, item: any) => handleMenuItemClick(e, item),
                  });
                }
                
                menuarray.push({
                  id: items1[index]["menuId"],
                  name: items1[index]["menuName"],
                  label: items1[index]["menuName"],
                  displayNo: items1[index]["displayNo"],
                  path: "",
                  Icon: FolderIcon,
                  items: childmenuarray.sort((a, b) => a.displayNo - b.displayNo),
                });
              }

              const sortedItems = menuarray.sort((a, b) => a.displayNo - b.displayNo);
              setMenuItems(sortedItems);
            }
          } else {
            if (location.pathname !== "/") {
              navigate("/");
            }
          }
        } catch (fallbackError) {
          console.error("Fallback also failed:", fallbackError);
          if (location.pathname !== "/") {
            navigate("/");
          }
        } finally {
          setLoading(false);
        }
      }
    };

    checkUserAndBuildMenu();
  }, [location.pathname, navigate]);

  const handleMenuItemClick = (e: any, item: any) => {
    console.log("Main " + item);
    let path = item.path;
    if (!path) {
      window.alert("Path Not Found");
    } else {
      navigate(path);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: `var(--main-background)`,
          backgroundImage: `var(--background-image)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  return (
    <div>
      {location.pathname === "/" ? (
        <Outlet />
      ) : (
        <div>
          <Box sx={{ display: "flex", marginTop: "2%" }}>
            <Sidebar items={menuItems} />
            <Box
              sx={{
                flexGrow: 1,
                px: 2,
                py: 2,
                width: `calc(100% - ${sizeConfigs.sidebar.width})`,
                minHeight: "100vh",
                backgroundColor: `var(--main-background)`,
                backgroundImage: `var(--background-image)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Toolbar />
              <Outlet />

              {/* Chatbot Icon with Image */}
              <Box
                sx={{
                  position: "fixed",
                  bottom: 20,
                  right: 5,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {isHovered && (
                  <Typography
                    variant="body2"
                    sx={{
                      marginRight: 1,
                      background: "rgba(0, 0, 0, 0.7)",
                      color: "white",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      position: "absolute",
                      bottom: "60px",
                      right: "25px",
                    }}
                  >
                    Ask Me...
                  </Typography>
                )}
                <Box
                  component="img"
                  src={ChatBotIcon}
                  alt="Chatbot"
                  sx={{
                    width: 50,
                    height: 50,
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={() => setIsChatBotOpen(true)}
                />
              </Box>
            </Box>
          </Box>

          {/* ChatBot Modal */}
          <ChatBot
            open={isChatBotOpen}
            onClose={() => setIsChatBotOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default MainLayout;

